import {Component, EventEmitter, Input, OnInit, SimpleChanges} from '@angular/core';
import {FieldDefinition} from "@shared/models/field-definition";
import {CellComponent} from "@shared/components/cell-components/cell-component";
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';


@Component({
    standalone: false,
    selector: 'app-cbc-required-edit-cell-viewer',
  templateUrl: './cbc-required-edit-cell-viewer.component.html',
  styleUrls: ['./cbc-required-edit-cell-viewer.component.scss']
})
export class CbcRequiredEditCellViewerComponent implements OnInit, CellComponent {

  item: any;
  fieldDefinition: any;
  sourceType: string;
  fieldDefinitionKeyModel = 'JT6_Model';
  valueChanged: EventEmitter<any> = new EventEmitter();



  constructor(
  ) {
  }
  validationChange?: EventEmitter<boolean>;
  invalidateSubject?: InvalidateSubject;
  disabled?: boolean;
  extras?: any;

  ngOnInit() {
    console.log("Yes");
    this.setIntialValues();
  }

  private setIntialValues() {

  }

  ngOnChanges(changes: SimpleChanges): void {
  }
  onClicked(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }

  openNote() {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, noteKey: 'JT38_Detail' ,action: {id: 'OpenNote'}})
  }

  editClicked() {
  }
}
